/* @ngInject */
function briefingService ($rootScope, $translate, ConnectorWebService, CONSTANTS, Utils) {
  const service = {
    getCompanyBriefing,
    getUserBriefing,
    getCompanyBriefings,
    countCompanyBriefings,
    updateFieldValue,
    downloadWithProgress,
    archiveBriefing,
    getFieldsTypes,
    updateBriefing,
    createBriefing,
    duplicateBriefing,
    isThereBriefingTasks,
    getUsedBriefingsByBoard,
    validateCompanyFeatures,
    checkBriefingsLimitReached,
    limitBriefingNameLength,
    findFieldByFieldId,
    sanitazeBriefingForm,
    someFields,
    filterFields,
    findFields,
    validateFormFields,
    validateFormSectionFields,
    isBriefingFormEmpty,
    isBriefingFieldEmpty,
    isLastSection,
    cleanFormFromSection,
    bindAuditBriefingToCampaign,
    unbindAuditBriefingFromCampaign,
    reorderFieldsAfterRemove,
    reorderFieldsAfterDuplicate,
    shareWithGuests,
    getSharedGuests,
    deleteSharedGuest,
    unbindBriefingFromCampaign
  }
  return service

  function getCompanyBriefing (briefingId, archivedFields) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_BRIEFING, [briefingId])

    if (typeof archivedFields === 'boolean') {
      url = Utils.fnAddQueryToUrl(url, { archivedFields })
    }

    return ConnectorWebService.get(url)
  }

  function getUserBriefing (briefingId, userId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BRIEFING_USER, [briefingId, userId])

    return ConnectorWebService.get(url)
  }

  function getCompanyBriefings (type, bringArchived, search, top, skip, isAnalytics, sort) {
    let url = CONSTANTS.URL_CUSTOMER_BRIEFINGS

    if (type) {
      url = Utils.fnAddQueryToUrl(url, { type })
    }
    if (bringArchived) {
      url = Utils.fnAddQueryToUrl(url, { bringArchived })
    }

    if (search) {
      url = Utils.fnAddQueryToUrl(url, { search })
    }

    if (isAnalytics) {
      url = Utils.fnAddQueryToUrl(url, { isAnalytics })
    }

    if (sort) {
      url = Utils.fnAddQueryToUrl(url, { $sort: sort.name, $order: sort.order })
    }

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    return ConnectorWebService.get(url)
  }

  function getFieldsTypes () {
    return ConnectorWebService.get(CONSTANTS.URL_CUSTOMER_BRIEFINGS_TYPES)
  }

  function updateFieldValue (id, payload) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BRIEFING_FIELD_ID, [id])
    return ConnectorWebService.put(url, payload)
  }

  function updateBriefing (id, payload) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BRIEFING_ID, [id])
    return ConnectorWebService.put(url, payload)
  }

  function createBriefing (payload) {
    return ConnectorWebService.post(CONSTANTS.URL_BRIEFINGS, payload)
  }

  function archiveBriefing (id, archive = true) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_BRIEFING_ID, [id])
    url = Utils.fnAddQueryToUrl(url, { archive })
    return ConnectorWebService.fnDelete(url)
  }

  function downloadWithProgress (id, progressCallback, callback, options) {
    const constantUrl = options && options.isTempFile ? CONSTANTS.URL_TEMPORARY_FILES_UUID : CONSTANTS.URL_BRIEFING_ATTACHMENT_DOWNLOAD
    let url = Utils.fnReplaceStringParams(constantUrl, [id])

    if (options && options.query) {
      url = Utils.fnAddQueryToUrl(url, options.query)
    }

    return ConnectorWebService.createCustomXHR(url, 'GET', null, { responseType: 'blob' }, { progress: progressCallback }, options || {})
      .then(function (blob) {
        callback(blob)
      })
  }

  function countCompanyBriefings (type) {
    let url = CONSTANTS.URL_CUSTOMER_BRIEFINGS_COUNT

    if (type) {
      url = Utils.fnAddQueryToUrl(url, { type })
    }

    return ConnectorWebService.get(url)
  }

  function duplicateBriefing (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BRIEFING_ID_DUPLICATE, [id])
    return ConnectorWebService.post(url)
  }

  function isThereBriefingTasks (briefingId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BRIEFING_ID_TASKS, [briefingId])
    return ConnectorWebService.get(url)
  }

  function getUsedBriefingsByBoard (boardId, options = {}) {
    const {
      search,
      top: $top,
      skip: $skip
    } = options
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_BRIEFING_BOARD_ID, [boardId])

    if ($top) {
      url = Utils.fnAddQueryToUrl(url, { $top })
    }

    if ($skip) {
      url = Utils.fnAddQueryToUrl(url, { $skip })
    }

    if (search) {
      url = Utils.fnAddQueryToUrl(url, { search })
    }

    return ConnectorWebService.get(url)
  }

  function limitBriefingNameLength (briefingName, charactersLimit) {
    const limit = charactersLimit || 43

    return Utils.truncateText(briefingName, limit)
  };

  function checkBriefingsLimitReached (briefingsLimit) {
    return getCompanyBriefings('WORKFLOW', true).then(allBriefings => {
      const briefings = allBriefings.rows

      const activeBriefings = briefings.filter(briefing => {
        return !briefing.isArchived
      })

      const activeBriefingsCounter = activeBriefings.length

      return { briefingsLimit, briefingsLimitReached: briefingsLimit != null && activeBriefingsCounter >= briefingsLimit }
    })
  }

  function validateCompanyFeatures () {
    const companyFeatures = {
      maxBriefings: {
        featureName: $translate.instant('billingFeatures.workflowMaxBriefings'),
        featureSlug: 'WORKFLOW.MAX_BRIEFINGS',
        briefingsLimit: null,
        briefingsLimitReached: false
      }
    }

    return $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
      companyFeatures.maxBriefings.briefingsLimit = features['WORKFLOW.MAX_BRIEFINGS'].limit

      return checkBriefingsLimitReached(companyFeatures.maxBriefings.briefingsLimit).then(limitReached => {
        companyFeatures.maxBriefings.briefingsLimitReached = limitReached.briefingsLimitReached

        return companyFeatures
      })
    })
  }

  function filterFields (briefing, filerFunction) {
    const results = []
    briefing.sections.forEach(section => {
      const fields = section.fields.filter(filerFunction)
      results.push(...fields)
    })

    return results
  }

  function someFields (briefing, someFunction) {
    let result = false
    briefing.sections.forEach(section => {
      const sectionResult = section.fields.some(someFunction)
      if (sectionResult) {
        result = true
      }
    })

    return result
  }

  function findFields (briefing, findFunction) {
    let result = null
    briefing.sections.forEach(section => {
      const sectionResult = section.fields.find(findFunction)
      if (sectionResult) {
        result = sectionResult
      }
    })

    return result
  }

  function findFieldByFieldId (fieldId, sections) {
    let field = null
    let index = 0

    while (!field && index < sections.length) {
      const fieldObj = sections[index].fields.find(item => item.id.toString() === fieldId.toString())

      if (fieldObj) {
        field = fieldObj
        field.sectionId = sections[index].id
      } else {
        index++
      }
    }

    return field
  }

  function validateFormFields (form) {
    let hasEmptyField = false
    let index = 0

    while (hasEmptyField && index < form.sections.length) {
      const sectionHasEmptyField = this.validateFormSectionFields(form.sections[index])

      if (sectionHasEmptyField) {
        hasEmptyField = true
      } else {
        index++
      }
    }

    return hasEmptyField
  }

  function sanitazeBriefingForm (briefing) {
    function handleOptions (option) {
      option.id = option.id || option.value
      option.title = option.title || option.label
      delete option.value
      delete option.label
    }

    briefing.sections.forEach(section => {
      delete section.sortableObj
      section.fields.forEach(field => {
        if (field.actions) {
          field.actions.forEach(action => {
            if (field.defaultRadioOptions) {
              const options = Array.isArray(action.options) ? [...action.options] : [action.options]
              action.options = options
            }
            action.options.forEach(handleOptions)
          })
        }
      })
    })

    // Garantir que será um número ao invés de string. Caso seja string ("") será convertido pra null
    briefing.boardId = briefing.boardId ? Number(briefing.boardId) : null
  }

  function validateFormSectionFields (section) {
    return section.fields.some(field => (
      field.mandatory &&
      (Utils.valueIsEmpty(field.value) ||
      field.loadingFiles > 0)
    ))
  }

  function isBriefingFormEmpty (form) {
    return form.sections.every(section => this.isBriefingFieldEmpty(section))
  }

  function isBriefingFieldEmpty (section) {
    const hasFieldFilled = (
      section.fields &&
      section.fields.find(field => (
        !Utils.valueIsEmpty(field?.value) ||
        field?.loadingFiles > 0
      )
      )
    )

    return hasFieldFilled === undefined
  }

  function isLastSection (sectionId, sections) {
    const index = sections.findIndex(section => section.id === sectionId)

    if (index !== -1) {
      return index === sections.length - 1
    } else {
      return false
    }
  }

  function cleanFormFromSection (sectionId, sections) {
    const index = sections.findIndex(section => section.id === sectionId)

    if (index !== -1) {
      for (let i = index + 1; i < sections.length; i++) {
        sections[i].fields.forEach(field => {
          if (!field.businessDataField?.contexts?.length) {
            field.value = null
            field.clearAttachments = true
          }
        })
      }
    }
  }

  function bindAuditBriefingToCampaign (params = {}) {
    const { assetId, selectedCampaign } = params

    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BRIEFING_ID_BIND_CAMPAIGN, [assetId])
    return ConnectorWebService.put(url, { campaignId: selectedCampaign })
  }

  function unbindAuditBriefingFromCampaign (assetId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BRIEFING_ID_UNBIND_CAMPAIGN, [assetId])
    return ConnectorWebService.put(url)
  }

  function reorderFieldsAfterRemove (fields, startIndex) {
    for (let i = startIndex; i < fields.length; i++) {
      fields[i].order--
    }
  }

  function reorderFieldsAfterDuplicate (fields, startIndex) {
    for (let i = startIndex; i < fields.length; i++) {
      fields[i].order++
    }
  }

  function shareWithGuests (id, data) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_BRIEFING, [id])
    return ConnectorWebService.post(url, data)
  }

  function getSharedGuests (id, top, skip) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_SHARE_BRIEFING, [id])

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    return ConnectorWebService.get(url)
  }

  function deleteSharedGuest (id, guestId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_DELETE_BRIEFING_ACCESS, [id, guestId])
    return ConnectorWebService.fnDelete(url)
  }

  function unbindBriefingFromCampaign (assetId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_BRIEFING_ID_UNBIND_CAMPAIGN, [assetId])
    return ConnectorWebService.put(url)
  }
}

export { briefingService }
